import { Button, Modal } from "antd";
import React from "react";
import Icon from "../../assets/Icon";

function TestModal({ testModal, setTestModal }) {
  return (
    <Modal
      open={testModal}
      onCancel={() => setTestModal(false)}
      title={
        <div>
          <Icon type="mic-icon" />
        </div>
      }
      footer={null}
    >
      <div className="mt-4">
        <p className="font-semibold text-lg">Audio Access</p>
        <p className="text-[#475467]">
          Kindly test your microphone and speaker to enable audio access.
        </p>
      </div>
      <div>
        <div className="mt-6 flex justify-between items-center">
          <div>
            <p className="font-semibold text-[#344054]">Microphone</p>
            <p className="text-[#475467]">
              Speak into your microphone to test if its working
            </p>
          </div>
          <div>
            <button className="btn-blue px-6 py-1">Test</button>
          </div>
        </div>
      </div>
      <div>
        <div className="mt-6 flex justify-between items-center">
          <div>
            <p className="font-semibold text-[#344054]">Speaker</p>
            <p className="text-[#475467]">
              Click to play a test sound and confirm you can hear it.{" "}
            </p>
          </div>
          <div>
            <button className="btn-blue px-6 py-1">Test</button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default TestModal;
